export default {
    binCell: {
        ariaLabel: 'Interval {index}, {start} do {end}, vrednost {value} MWh',
    },
}
